import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  encryptData,
  formatDate,
  formatDateAndTime,
  serverLink,
} from "../../resources/Url";
import { showAlert } from "../../pages/sweetalert/sweetalert";
import axios from "axios";
import arrayShuffle from "array-shuffle";
import { setLoginDetails } from "../../actions/Actions";
import { connect } from "react-redux";
import NavBar from "./../NavBar";
import Footer from "./../Footer";
import Table from "../../pages/table/table";
import Header from "./../Header";
import HomeContentLoader from "./../HomeContentLoader/HomeContentLoader";
import SubmittingLoader from "./../SubmittingLoader/SubmittingLoader";

function AddPodcast(props) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();

  const [position, setPosition] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFile2, setSelectedFile2] = useState(null);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);

  const [station] = useState(
    typeof props?.HomePageData.stations !== "undefined"
      ? props?.HomePageData.stations
      : []
  );

  const [createItem, setCreateItem] = useState({
    PodcastId: "",
    Title: "",
    ShortDescription: "",
    LongDescription: "",
    Image: "",
    Audio: "",
    IsActive: "",
    StationId: "",
  });

  const resetItem = () => {
    setCreateItem({
      ...createItem,
      PodcastId: "",
      Title: "",
      ShortDescription: "",
      LongDescription: "",
      Image: "",
      Audio: "",
      IsActive: "",
      StationId: "",
    });
  };

  const [datatable, setDatatable] = useState({
    columns: [
      {
        label: "S/N",
        field: "sn",
      },
      {
        label: "Title",
        field: "Title",
      },
      {
        label: "Action",
        field: "action",
      },
    ],
    rows: [],
  });

  const navigate = useNavigate();
  const currentUser =
    JSON.parse(localStorage.getItem("EnyimbaLoginHistory")) || [];

  const onEdit = async (e) => {
    const id = e.target.id;
    const value = e.target.value;

    if (e.target.type === "file") {
      if (id === "image1") {
        setSelectedFile(e.target.files[0]);
      }
      if (id === "image2") {
        setSelectedFile2(e.target.files[0]);
      }
    } else {
      setCreateItem({
        ...createItem,
        [id]: value,
      });
    }
  };

  const getStaff = async () => {
    await axios
      .get(`${serverLink}shared/get/podcast`)
      .then((result) => {
        if (result.data.length > 0) {
          let rows = [];
          result.data.map((staff, index) => {
            const stationName = station.filter(
              (x) => x.StationId === staff.StationId
            )[0];

            rows.push({
              sn: index + 1,
              PodcastId: staff.PodcastId,
              Title: staff.Title,
              ShortDescription: staff.ShortDescription,
              LongDescription: staff.LongDescription,
              Image: staff.Image,
              Audio: staff.Audio,
              IsActive: staff.IsActive,
              StationId: staff.StationId,
              action: (
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ backgroundColor: "#a7613b" }}
                  data-toggle="modal"
                  data-target="#myModal"
                  onClick={() =>
                    setCreateItem({
                      PodcastId: staff.PodcastId,
                      Title: staff.Title,
                      ShortDescription: staff.ShortDescription,
                      LongDescription: staff.LongDescription,
                      Image: staff.Image,
                      Audio: staff.Audio,
                      IsActive: staff.IsActive,
                      StationId: staff.StationId,
                    })
                  }
                >
                  Edit
                </button>
              ),
            });
          });

          setDatatable({
            ...datatable,
            columns: datatable.columns,
            rows: rows,
          });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("NETWORK ERROR");
      });
  };

  useEffect(() => {
    getStaff().then((r) => {});
    const timeoutId = setTimeout(() => {
      setPosition(1);
      setIsLoading(false);
      if (currentUser.length === 0) {
        navigate("/auth");
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [currentUser]);

  const uploadImage = async (formData, endpoint) => {
    try {
      const response = await axios.post(`${serverLink}${endpoint}`, formData);
      if (response.data.type === "success") {
        return response.data.file.url;
      }
      throw new Error("Image upload failed.");
    } catch (error) {
      console.error("Image upload error:", error);
      throw error;
    }
  };
  const onSubmitProgram = async (e) => {
    setIsSubmittingForm(true);
    e.preventDefault();
    for (let key in createItem) {
      if (
        createItem.hasOwnProperty(key) &&
        key !== "PodcastId" &&
        key !== "Image" &&
        key !== "Audio"
      ) {
        if (createItem[key] === "") {
          await showAlert("EMPTY FIELD", `Please enter ${key}`, "error");
          setIsSubmittingForm(false);
          return false;
        }
      }
    }

    if (createItem.Audio.size / 1024 > 10000) {
      await showAlert("", `File Size Can't be more than 2MB`, "error");
      setIsSubmittingForm(false);
      return false;
    }

    if (createItem.Image.size / 1024 > 10000) {
      await showAlert("", `File Size Can't be more than 2MB`, "error");
      setIsSubmittingForm(false);
      return false;
    }

    if (createItem.Title) {
      const image1 = new FormData();
      image1.append("image1", selectedFile);

      const image2 = new FormData();
      image2.append("image2", selectedFile2);

      const image =
        selectedFile &&
        selectedFile.size > 0 &&
        (await uploadImage(image1, "podcast/upload/image1"));

      const audio =
        selectedFile2 &&
        selectedFile2.size > 0 &&
        (await uploadImage(image2, "podcast/upload/image2"));

      const sendData = {
        PodcastId: createItem.PodcastId,
        Title: createItem.Title,
        ShortDescription: createItem.ShortDescription,
        LongDescription: createItem.LongDescription,
        Image: image,
        Audio: audio,
        IsActive: createItem.IsActive,
        StationId: createItem.StationId,
      };

      if (createItem.PodcastId === "") {
        axios
          .post(`${serverLink}podcast/add`, sendData)
          .then(async (res) => {
            if (res.data.message === "success") {
              await showAlert(
                "Success",
                `Podcast Added Successfully`,
                "success"
              );
              resetItem();
              await getStaff();
              setIsSubmittingForm(false);
            }
            if (res.data.message === "exist") {
              await showAlert(
                "Error",
                `Podcast with given details already exist!`,
                "error"
              );
              setIsSubmittingForm(false);
            }
          })
          .catch((error) => {
            console.log("Error", error);
          });
      }
      if (createItem.PodcastId !== "") {
        await axios
          .patch(`${serverLink}podcast/update`, sendData)
          .then((result) => {
            if (result.data.message === "success") {
              showAlert("Success", "Podcast Updated Successfully", "success");
              resetItem();
              getStaff();
              setIsSubmittingForm(false);
            } else {
              showAlert(
                "ERROR",
                "Something went wrong. Please try again!",
                "error"
              );
              setIsSubmittingForm(false);
            }
          })
          .catch((error) => {
            showAlert(
              "NETWORK ERROR",
              "Please check your connection and try again!",
              "error"
            );
            setIsSubmittingForm(false);
          });
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <HomeContentLoader />
      ) : (
        <div id="wrapper">
          <Header />
          <NavBar />
          <div id="page-wrapper">
            <div class="header">
              <h1 class="page-header">Manage Podcast</h1>
            </div>
            <div id="page-inner">
              <div class="row">
                <div class="col-md-12">
                  <div class="panel panel-default">
                    <div class="panel-heading"></div>

                    <div class="panel-body">
                      <div className="panel-body">
                        <button
                          style={{
                            backgroundColor: "#a7613b",
                            float: "right",
                          }}
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#myModal"
                          onClick={resetItem}
                        >
                          Add Podcast
                        </button>
                        <div
                          className="modal fade"
                          id="myModal"
                          tabIndex="-1"
                          role="dialog"
                          aria-labelledby="myModalLabel"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog">
                            <div
                              className="modal-content"
                              style={{
                                width: "700px",
                              }}
                            >
                              <div className="modal-header">
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                  aria-hidden="true"
                                >
                                  &times;
                                </button>
                                <h4 className="modal-title" id="myModalLabel">
                                  Podcast Component
                                </h4>
                              </div>
                              <div className="modal-body">
                                <div className="col-lg-6 mb-4">
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      id="Title"
                                      type="text"
                                      placeholder="Title"
                                      value={createItem.Title}
                                      onChange={onEdit}
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-6 mb-4">
                                  <div className="form-group">
                                    <select
                                      className="form-control"
                                      id="StationId"
                                      name="StationId"
                                      onChange={onEdit}
                                      value={createItem.StationId}
                                    >
                                      <option value="">Select Station</option>
                                      <option value="0">All Stations</option>
                                      {station &&
                                        Object.keys(station).length > 0 &&
                                        station.map((item, index) => {
                                          return (
                                            <option
                                              key={index}
                                              value={item.StationId}
                                            >
                                              {item.StationName}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </div>

                                <div className="col-lg-12 mb-4">
                                  <div className="form-group">
                                    <textarea
                                      className="form-control"
                                      id="ShortDescription"
                                      type="text"
                                      style={{
                                        height: "100px",
                                      }}
                                      placeholder="Short Description"
                                      value={createItem.ShortDescription}
                                      onChange={onEdit}
                                    ></textarea>
                                  </div>
                                </div>

                                <div className="col-lg-12 mb-4">
                                  <div className="form-group">
                                    <textarea
                                      className="form-control"
                                      id="LongDescription"
                                      type="text"
                                      style={{
                                        height: "100px",
                                      }}
                                      placeholder="Long Description"
                                      value={createItem.LongDescription}
                                      onChange={onEdit}
                                    ></textarea>
                                  </div>
                                </div>

                                <div className="col-lg-12 mb-4 ">
                                  <div className="form-group">
                                    <select
                                      id="IsActive"
                                      className="form-control"
                                      value={createItem.IsActive}
                                      onChange={onEdit}
                                    >
                                      <option value="">Select Status</option>
                                      <option value="1">Active</option>
                                      <option value="0">InActive</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="col-lg-6 mb-4">
                                  <div className="form-group">
                                    <label htmlFor="image1">
                                      Podcast Cover
                                    </label>
                                    <input
                                      type="file"
                                      accept=".jpg, .png"
                                      id="image1"
                                      name="image1"
                                      placeholder="OAP Passport"
                                      onChange={onEdit}
                                    />
                                    <span className="alert-info">
                                      Only .png, .jpg
                                    </span>
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-4">
                                  <div className="form-group">
                                    <label htmlFor="image2">Podcast File</label>
                                    <input
                                      type="file"
                                      id="image2"
                                      name="image2"
                                      placeholder="Podcast File"
                                      onChange={onEdit}
                                    />
                                    <span className="alert-info">
                                      Only audio file
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-default"
                                  data-dismiss="modal"
                                  style={{
                                    backgroundColor: "#da3535",
                                    color: "white",
                                  }}
                                  onClick={getStaff}
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  style={{ backgroundColor: "#a7613b" }}
                                  className="btn btn-primary"
                                  onClick={onSubmitProgram}
                                >
                                  Save changes
                                </button>
                                {isSubmittingForm && <SubmittingLoader />}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div class="panel panel-default">
                          <div class="panel-heading">Podcast List</div>
                          <div className="card-body pt-0">
                            <Table data={datatable} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    HomePageData: state.HomePageContents,
    UserProfile: state.LoginDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setOnLoginDetails: (p) => {
      dispatch(setLoginDetails(p));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPodcast);
